import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { StockInPrinResponse } from "./stock-in-print-response";

export class StockinPrintResponseModel extends GlobalResponseObject{
    data?:StockInPrinResponse[];
    /**
     * 
     * @param status
     * @param intlCode
     * @param internalMessage
     * @param data
     */


     constructor(status: boolean, intlCode: number, internalMessage: string, data?: StockInPrinResponse[]){
        super(status, intlCode, internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}